import React from 'react';
import { Configurations } from '../../Utils/Configurations';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import moment from 'moment';
import axios from 'axios';



class ModalReenvioImpressos extends React.Component {

    constructor(props) {
        super(props);

        this.getApiListaEdicoes = this.getApiListaEdicoes.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.salvarReenvioImpressos = this.salvarReenvioImpressos.bind(this);
        this.handleError = this.handleError.bind(this);
        this.obtemTipoBadge = this.obtemTipoBadge.bind(this);
        this.cancelarReenvio = this.cancelarReenvio.bind(this);

        this.Configurations = new Configurations();
        this.state = {
            motivo: this.props.dadosReenvio ? this.props.dadosReenvio.motivoReenvio : '',
            edicoesDisponiveisOptions: [],
            isLoadingSalvarReenvioPeriodicos: false,
            hasError: false,
            isLoadingListaEdicoesDisponiveis: false,
            isLoadingCancelamentoReenvio: false,
            idItem: this.props.item.idItem
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen !== prevProps.isOpen) {
            if (this.props.isOpen) {
                this.getApiListaEdicoes();
                this.setState({
                    motivo: this.props.dadosReenvio ? this.props.dadosReenvio.motivoReenvio : '',
                })
            } else this.setState({
                motivo: '',
                edicoesDisponiveisOptions: [],
                edicoesReenvioSelecionadas: []
            })
        }
    }

    getApiListaEdicoes() {
        this.setState({ isLoadingListaEdicoesDisponvieis: true })
        axios.get(this.Configurations.apiBasePath + `/logistica/reenvio/edicoes-disponiveis/${this.state.idItem}`).then(response => {
            const edicoesDisponiveisOptions = response.data.edicoesDisponiveis.map(item => ({

                // Outra forma de mostrar a lista com concatenação
                // label: "Ed. " + item.numEdicao + " - " + moment(item.dtPublicacao).format("DD/MM/YY"), value: item.idEdicao
                label: `Ed. ${item.edicaoNumero} - ${moment(item.dtEntrega).format("DD/MM/YY")}`, value: item.idEdicao
            }))
            const listaNumeroEdicoes = !!this.props.dadosReenvio ? this.props.dadosReenvio.edicoes.map(n => n.idEdicao) : undefined
            const edicoesReenvioSelecionadas = !!listaNumeroEdicoes ? edicoesDisponiveisOptions.filter(i => listaNumeroEdicoes.indexOf(i.value) >= 0) : []

            this.setState({
                edicoesDisponiveisOptions: edicoesDisponiveisOptions,
                edicoesReenvioSelecionadas: edicoesReenvioSelecionadas,

            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingListaEdicoesDisponiveis: false }));
    }

    onChangeInput(e) {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }

    salvarReenvioImpressos() {
        const reenvio = {
            idItem: this.state.idItem,
            motivo: this.state.motivo,
            edicoes: this.props.listaIdEdicoes.map(item => {
                return {
                    idEdicao: item.value
                }
            })
        }
        this.setState({ isLoadingSalvarReenvioPeriodicos: true })

        axios.post(this.Configurations.apiBasePath + `/logistica/reenvio/itens-reenvio`, reenvio).then(response => {
            this.setState({
                edicoesDisponiveisOptions: [],
                edicoesReenvioSelecionadas: [],
                edicoes: [],
                idItem: undefined,
                motivo: '',
                hasError: false
            }, () => { this.props.toggle() })
            this.props.getOrderDetails();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingSalvarReenvioPeriodicos: false }))
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: (!!err.response && !!err.response.data && !!err.response.data.message) ? err.response.data.message : 'Erro inesperado.' })
    }

    obtemTipoBadge(tipo) {

        let _tipoBadge;
        let _textColorInside = 'white';
        let _textColorOutside;

        switch (tipo.toLowerCase()) {
            case "bd":
                _tipoBadge = 'water';
                _textColorOutside = _tipoBadge;
                break;
            case "bm":
                _tipoBadge = 'verde';
                _textColorOutside = _tipoBadge;
                break;
            case "tc":
                _tipoBadge = 'danger';
                _textColorOutside = _tipoBadge;
                break;
            case "rd":
                _tipoBadge = 'warning';
                _textColorOutside = 'info';
                _textColorInside = 'info';
                break;
            case "bj":
                _tipoBadge = 'success';
                _textColorOutside = _tipoBadge;
                break;
            case "da":
                _tipoBadge = 'secondary';
                _textColorOutside = _tipoBadge;
                break;
            default:
                _tipoBadge = 'primary';
                _textColorOutside = _tipoBadge;
                break;
        }

        return {
            textColorInside: `${_textColorInside}`,
            badgeColor: `${_tipoBadge}`,
            textColorOutside: `${_textColorOutside}`
        }
    }

    cancelarReenvio() {
        this.setState({ isLoadingCancelamentoReenvio: true })
        axios.delete(this.Configurations.apiBasePath + `/logistica/reenvio/itens-reenvio/${this.props.dadosReenvio.idItemReenvio}`).then(response => {
            this.setState({
                motivo: '',
                edicoesReenvioSelecionadas: [],
                edicoesDisponiveisOptions: [],
                edicoes: []
            }, () => { this.props.toggle() })
            this.props.getOrderDetails();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingCancelamentoReenvio: false }))
    }


    render() {
        const {
            isOpen,
            toggle,
            listaIdEdicoes,
            handleSelectChange,
            item,
        } = this.props;

        return (

            <Modal className="modalReenvioImpressos" size="lg" isOpen={isOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}>Reenvio de periódicos</ModalHeader>
                <ModalBody>
                    <div className='col-12'>
                        <div className='row'>
                            <div className='col-6'>
                                <span>Produto: </span><span className={`badge badge-${this.obtemTipoBadge(item.sigla).badgeColor}`}>
                                    {item.produto}
                                </span>
                            </div>
                            <div className='col-6'>
                                Vigência: <strong>{moment(item.dtInicio).format('DD/MM/YYYY')} - {moment(item.dtFim).format('DD/MM/YYYY')}</strong>
                            </div>
                        </div>
                        {this.state.isLoadingListaEdicoesDisponiveis ? (
                            <div className="row no-gutters">
                                <div className="col-12 text-center py-5">
                                    <div className="spinner-border text-primary" role="status" />
                                </div>
                            </div>
                        ) : (
                            <div className='row py-3'>
                                <div className='col-6'>
                                    <div className='form-group'>
                                        <label htmlFor='edicoesDisponiveis'>Edições disponíveis:</label>
                                        {this.state.edicoesDisponiveisOptions.length > 0 ? (
                                            <Select
                                                id="edicoesDisponiveis"
                                                placeholder="Selecione um ou mais edições"
                                                closeMenuOnSelect={true}
                                                components={makeAnimated()}
                                                defaultValue={this.state.edicoesReenvioSelecionadas}
                                                isMulti
                                                name="edicoesDisponiveisOptions"
                                                onChange={handleSelectChange}
                                                options={this.state.edicoesDisponiveisOptions}
                                            />
                                        ) : (
                                            <p><strong>Não há edições disponíveis</strong></p>
                                        )}
                                    </div>
                                </div>
                                <div className="col-6">
                                    <label htmlFor='descMotivoReenvio'>Motivo (obrigatório)</label>
                                    <textarea id="descMotivoReenvio" autoComplete="off" name="motivo" className="form-control" type="text" value={this.state.motivo} onChange={this.onChangeInput} />
                                </div>
                            </div>
                        )}

                        <div className='row'>
                            {this.props.dadosReenvio ? (
                                <React.Fragment>
                                    {this.state.isLoadingCancelamentoReenvio ? (
                                        <div className="col-12 text-right">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    ) : (
                                        <div className='col-12 text-right'>
                                            <button className='mx-3 btn btn-outline-danger' onClick={this.cancelarReenvio}>Cancelar</button>
                                        </div>
                                    )}
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    {this.state.isLoadingSalvarReenvioPeriodicos ? (
                                        <div className="col-12 text-right">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    ) : (
                                        <div className='col-12 text-right'>
                                            <button className='mx-3 btn btn-outline-success' disabled={(listaIdEdicoes.length <= 0) || (this.state.motivo.trim() === '')} onClick={this.salvarReenvioImpressos}>Salvar</button>
                                        </div>
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                        <div className='row py-3 '>
                            <div className='col-12 text-center text-danger'>
                                {this.state.hasError && (
                                    <span>{this.state.errorMessage}</span>
                                )}
                            </div>
                        </div>

                    </div>
                </ModalBody>
            </Modal >
        )
    }
}

export default ModalReenvioImpressos 